import instance from "./index";
import { getCookie } from "@/utils/commonfunctions";

const needCsrfMethods = ["post", "POST", "put", "PUT", "delete", "DELETE"];

const setup = () => {
  instance.interceptors.request.use(
    (config: any) => {
      config.headers["X-CSRF-Token"] = getCookie("__Host-BCSRF");
      config.headers["Access-Control-Allow-Origin"] = import.meta.env.VITE_BASE_URL;
      if (needCsrfMethods.includes(config.method)) {
        config.withCredentials = true;
      }
      return config;
    },
    (error: any) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (res: any) => {
      return res;
    },
    async (error: any) => {
      // const originalConfig = error.config;
      
      // if (
      //   error.code === "ERR_NETWORK" &&
      //   window.location.pathname !== "/error/network"
      // )
      //   return window.open(window.location.origin + "/error/network", "_self");
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/auth/login"
      )
        return window.open(window.location.origin + "/auth/login", "_self");
      // if (error.response.status === 404){
      //   console.error("API Route or data is not exist");
      // }
      
      return Promise.reject(error);
    }
  );
};

export default setup;
